module.exports = __webpack_public_path__ + "img/ded-stock-3.aeffee13.png";